// @<COPYRIGHT>@
// ==================================================
// Copyright 2021.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { AppCtxComponent } from 'js/reactAppCtx';
import AwProgressIndicator from 'viewmodel/AwProgressIndicatorViewModel';

export default class DesCollabProgressBar extends HTMLElement {
    /**
     * Lifecycle function invoked when the custom html
     * element is rendered
     */
    connectedCallback() {
        console.log(`des-collab-progress-bar connected call back`);
        ReactDOM.render(
            <AppCtxComponent>
                {this.createReactElement()}
            </AppCtxComponent>, this);
    }

    /**
     * Helper function
     */
    createReactElement() {
        return React.createElement( AwProgressIndicator,
                                    {accsessionid: this.accsessionid, name: 'collab'},
                                    React.createElement( 'slot' ) );
    }

    get accsessionid() {
        console.log(`des-collab-progress-bar Returning value of accsessionid`);
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id'];
    }

    attributeChangedCallback (name, oldValue, newValue) {
        this.debounceCreateElement();
    }

    debounceCreateElement() {
        const _this = this;
        if (_this.debounceFuncRef) {
            clearTimeout(_this.debounceFuncRef);
        }

        _this.debounceFuncRef = setTimeout(() => {
            ReactDOM.render(
                <AppCtxComponent>
                    {_this.createReactElement()}
                </AppCtxComponent>, _this);
        }, 1000);
    }

    disconnectedCallback() {
        ReactDOM.render( null, this );
    }
}

if (!window.customElements.get('des-collab-progress-bar')) {
    window.customElements.define( 'des-collab-progress-bar', DesCollabProgressBar );
}
